"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrialId = void 0;

var _getAvailableTrials = require("self-service-api/api/getAvailableTrials");

var _validators = require("self-service-api/core/validators");

var _Trials = require("self-service-api/constants/Trials");

var _trialIdAdapter = _interopRequireDefault(require("self-service-api/adapters/trialIdAdapter"));

var getTrialId = function getTrialId(upgradeProduct) {
  (0, _validators.validateUpgradeProduct)(upgradeProduct);
  var merchandiseId = _Trials.upgradeProductToMerchIds[upgradeProduct];
  if (!merchandiseId) return null;
  return (0, _getAvailableTrials.getAvailableTrials)().then(function (availableTrials) {
    return (0, _trialIdAdapter.default)(availableTrials, merchandiseId);
  });
};

exports.getTrialId = getTrialId;